// null 처리
export const isnull = (val) => {
    var ret = false;
    // need object handle
    if (typeof val == "undefined") {
        ret = true;
    }
    else if (val == null) {
        ret = true;
    }
    else if (val.length <= 0) {
        ret = true;
    }
    return ret;
};
export const handleUrl = (e, item, val, navigate, setUrl, opts) => {
    if (e === null || e === void 0 ? void 0 : e.preventDefault)
        e.preventDefault(); // 기본 이벤트 방지
    // val이 null이면 기본 페이지로 이동
    if (!val) {
        navigate(item);
        window.scrollTo({ top: 0 });
        return;
    }
    // 1) 목적지 기본값
    let dest = String(val.url || '');
    const currentQs = new URLSearchParams(window.location.search);
    const rawLang = (currentQs.get('lang') || '').toUpperCase();
    const langParam = rawLang === 'ENG' ? 'ENG' : 'KOR';
    const [basePath, destQuery = ''] = dest.split('?');
    const qs = new URLSearchParams(destQuery);
    qs.set('lang', langParam);
    // 4) 옵션에 따라 detail / write / id 처리
    if ((opts === null || opts === void 0 ? void 0 : opts.mode) === 'write') {
        qs.set('write', ''); // 일단 빈값으로 넣고 나중에 '=’ 제거
    }
    else if ((opts === null || opts === void 0 ? void 0 : opts.mode) === 'detail') {
        qs.set('detail', ''); // 일단 빈값으로 넣고 나중에 '=’ 제거
    }
    if (opts === null || opts === void 0 ? void 0 : opts.id) {
        qs.set('id', String(opts.id));
    }
    // 5) 직렬화 후 detail= / write= 의 = 제거 → '&detail', '&write'
    let query = qs.toString();
    // URLSearchParams는 빈 값을 `key=`로 직렬화하므로 후처리
    query = query
        .replace(/(^|&)detail=(?=(&|$))/g, '$1detail')
        .replace(/(^|&)write=(?=(&|$))/g, '$1write');
    // 6) 최종 목적지
    const finalUrl = query ? `${basePath}?${query}` : basePath;
    // 7) 이동
    navigate(finalUrl);
    // 8) 로컬스토리지 업데이트 (depth1, depth2)
    setUrl({ depth1: item, depth2: val });
    // 9) 스크롤 최상단으로 이동
    window.scrollTo({ top: 0 });
};
// 다운로드
export const handleDownload = (e, item, fileName) => {
    if (e === null || e === void 0 ? void 0 : e.preventDefault)
        e.preventDefault(); // 기본 이벤트 방지
    var blob = new Blob([item], { type: 'multipart/form-data' });
    var objURL = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.download = fileName;
    a.href = objURL;
    a.style.display = "none";
    // for new window
    a.target = "_blank";
    a.rel = 'noreferrer';
    //
    document.body.appendChild(a); //
    a.click();
    a.remove(); //
    window.URL.revokeObjectURL(objURL);
};
// 팝업열기
export const popupOpen = (id) => {
    const popId = document.getElementById(`${id}`);
    if (!isnull(popId))
        popId.setAttribute("style", "display: flex;");
};
// 팝업 닫기
export const popupClose = (id) => {
    const popId = document.getElementById(`${id}`);
    if (!isnull(popId))
        popId.setAttribute("style", "display: none;");
};
